import React from "react";
import { useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4">
      <div className="max-w-md w-full bg-card border border-border rounded-3xl p-8 text-center x-fade">
        <XCircle className="w-12 h-12 text-muted-foreground mx-auto mb-4" />
        <h1 className="font-heading text-xl font-bold">Checkout cancelled</h1>
        <p className="text-sm text-muted-foreground mt-2">No charge was made. You can get verified anytime.</p>
        <Button data-testid="cancel-back-btn" onClick={() => navigate("/")} className="mt-6 rounded-xl bg-[#6C0BA9] hover:bg-[#8012C6] text-white">Back to Feed</Button>
      </div>
    </div>
  );
}
